import React, { useState } from 'react';
import { CustomerType, IBosCustomer } from 'next-common';
import { CustomerFormType, CustomerForm } from './CustomerForm';
import { cn } from 'types';
import { CheckBox, Button } from '@repo/ui/components';

export interface ICustomerSelectedProps {
  customer: IBosCustomer;
  customerType: CustomerType;
  customerFormType: CustomerFormType;
  isSavingCustomer: boolean;
  queryString?: string;
  submitForm(formData: IBosCustomer): void;
  onClose?(): void;
}

export const Confirmation = (props) => (
  <div className="confirmation-checkbox">
    <CheckBox
      checked={props?.isCustomerConfirmed || false}
      label="Jeg bekrefter at informasjonen er riktig"
      id="confirmation-checkbox"
      onChange={() => props?.onConfirm(!props?.isCustomerConfirmed || false)}
    />
  </div>
);

const ConfirmationFooter = (props) => (
  <div className="flex gap-4 flex-grow pt-4">
    <Button
      className="w-full"
      disabled={!props.isValidForm}
      onClick={props.submitForm}
      isLoading={props.isSavingCustomer}
      variant="teal"
    >
      <span className="text-base/[175%]">Lagre</span>
    </Button>
    <Button className="w-full" appearance="outline" onClick={props.onClose} variant="teal">
      <span className="text-base/[175%]">Avbryt</span>
    </Button>
  </div>
);

export const CustomerSelected = (props: ICustomerSelectedProps) => {
  const [isValidForm, setIsValidForm] = useState(false);
  const [isCustomerConfirmed, setIsCustomerConfirmed] = useState(false);
  const [formData, setFormData] = useState<IBosCustomer>(null);
  const toggleCustomerConfirmed = (value) => {
    setIsCustomerConfirmed(value);
  };
  const updateValidation = (value: boolean) => {
    setIsValidForm(value);
  };

  const updatedFormData = (customer: IBosCustomer) => {
    setFormData(customer);
  };

  const submitForm = () => {
    if (typeof props.submitForm === 'function') {
      props.submitForm(formData);
    }
  };

  return (
    <div className={cn('flex flex-col gap-6 p-6')}>
      <CustomerForm
        customer={props.customer}
        customerType={props.customerType}
        updatedFormData={updatedFormData}
        updateValidation={updateValidation}
      />
      <Confirmation isCustomerConfirmed={isCustomerConfirmed} onConfirm={(value) => toggleCustomerConfirmed(value)} />
      <ConfirmationFooter
        isValidForm={isValidForm && isCustomerConfirmed}
        submitForm={submitForm}
        isSavingCustomer={props.isSavingCustomer}
        onClose={props.onClose}
      />
    </div>
  );
};
